import {useCallback, useContext, useEffect, useState} from 'react';
import {TextFormatAlignmentBase} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/TextFormat/components/Alignment/TextFormatAlignmentBase/TextFormatAlignmentBase';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {LeftAlignIcon} from '~library/svg/LeftAlignIcon';
import {MiddleAlignIcon} from '~library/svg/MiddleAlignIcon';
import {RightAlignIcon} from '~library/svg/RightAlignIcon';

export const Alignment = ({className}) => {
  const {canvas, activeObjects} = useContext(EventCreateContext);
  const [selectedAlignment, setAlignment] = useState();

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    const updateAlignment = () => setAlignment(canvas?.getActiveObjects()?.[0]?.textAlign);

    updateAlignment();
    canvas?.on('object:reset', updateAlignment);

    return () => {
      canvas?.off('object:reset', updateAlignment);
    };
  }, [canvas, activeObjects]);

  const changeAlignment = useCallback(
    (align) =>
      canvas.getActiveObjects().forEach((obj) => {
        setAlignment(align);
        obj.set('textAlign', align);
        canvas.requestRenderAll();
        canvas.fire('object:modified');
      }),
    [canvas]
  );

  const leftAlignment = useCallback(() => changeAlignment('left'), [changeAlignment]);
  const middleAlignment = useCallback(() => changeAlignment('center'), [changeAlignment]);
  const rightAlignment = useCallback(() => changeAlignment('right'), [changeAlignment]);

  return (
    <div className={className}>
      <TextFormatAlignmentBase
        icon={LeftAlignIcon}
        onClick={leftAlignment}
        active={selectedAlignment === 'left'}
        dataQaId="step1-textformat-leftalign"
      />
      <TextFormatAlignmentBase
        icon={MiddleAlignIcon}
        onClick={middleAlignment}
        active={selectedAlignment === 'center'}
        dataQaId="step1-textformat-centeralign"
      />
      <TextFormatAlignmentBase
        icon={RightAlignIcon}
        onClick={rightAlignment}
        active={selectedAlignment === 'right'}
        dataQaId="step1-textformat-rightalign"
      />
    </div>
  );
};
